import { UTM_PARAM_NAMES } from 'shared/constants/utm';

export const getUtmSearchParams = (searchParams: URLSearchParams): URLSearchParams => {
  const utmParams = new URLSearchParams();

  UTM_PARAM_NAMES.forEach(paramName => {
    const value = searchParams.get(paramName);

    if (value) {
      utmParams.set(paramName, value);
    }
  });

  return utmParams;
};
